export const TRAINING_ROOT = 'training-resources';

export interface SalesConfiguration {
  showProductWholesalePrice?: boolean;
}

export interface BreadCrumb {
  label: string;
  link?: string;
  // same type as @angular/router/RouterLinkWithHref.queryParams
  // note: could be outdated at anytime
  queryParams?: { [key: string]: any };
}
